import {makeStyles} from "@material-ui/core/styles"
import React, {Fragment} from "react"
import IconButton from "@material-ui/core/IconButton"
import {Icon, Popover} from "@material-ui/core"
import EmojiPicker from "emoji-picker-react"
import UserEvent from "../../core/UserEvent"
import PropTypes from "prop-types";
import i18n from "../../core/i18n";

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: '0px',
        padding: '0',
    },
    label: {
        padding: '0.3em',
        borderRadius: '0px',
    }
}))

const useEmojiPickerStyles = makeStyles(theme => ({
    emoji: {
        '--epr-emoji-size': '1.4rem!important',
    }
}))

function EmojiToolButton(props) {
    const {value, icon, style = {}, onClick, 'aria-label': ariaLabel} = props
    const classes = useStyles()
    const emojiPickerStyles = useEmojiPickerStyles();
    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleEmojiClick = event => {
        const value = event.emoji
        onClick && onClick(new UserEvent({value}, event))
    }

    const open = Boolean(anchorEl)

    const title = i18n.translate(props.title)

    return (
        <Fragment>
            <IconButton value={value} classes={classes} style={style} onClick={handleClick}
                        title={title} aria-label={i18n.translate(ariaLabel) || title} >
                <Icon fontSize="small" >{icon}</Icon>
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <EmojiPicker className={emojiPickerStyles.emoji} width="20rem" height="30rem" onEmojiClick={handleEmojiClick} />
            </Popover>
        </Fragment>
    )
}

EmojiToolButton.propTypes = {
    value: PropTypes.string,
    icon: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    title: PropTypes.string,
    'aria-label': PropTypes.string,
}

export default EmojiToolButton